import { render, staticRenderFns } from "./MatiasBernola.vue?vue&type=template&id=7ed5d7de&"
import script from "./MatiasBernola.vue?vue&type=script&lang=js&"
export * from "./MatiasBernola.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports